module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ChapterPages_Space-Maker"
  }), _vm._v(" "), _c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _c('a', {
    attrs: {
      "href": "#/NothingsWrong5#_idTextAnchor002"
    }
  }, [_vm._v("one "), _c('br'), _c('br'), _c('span', {
    staticClass: "CharOverride-6"
  }, [_c('span', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Strangers No More"), _c('span', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_DropCap"
  }, [_c('span', {
    staticClass: "initial-cap _idGenCharOverride-3"
  }, [_vm._v("L")]), _vm._v("et’s begin with two guys: the man on the moon and the man in"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" the moon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("We know who the man on the moon is. He’s the astronaut walking on the lunar surface, brought there by logic, nerve, and courage. He’s the “thinking guy” of calculations and logic, predictable and exact. He is the man who is very interested in the external things of the world, like space travel and geology (as well as stocks and bonds, planes and boats, baseball and rugby, cell phones and fast cars). He has steely nerves and determination; he’s actually walked on the moon and returned to earth to tell"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" about it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Everyone ad"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("mires him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("We also know who the man "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("in")]), _vm._v(" the moon is—or do we? He’s not so easy to know. He’s a trickster. He has a vivid imagination and dreams a lot. He’s full of surprises. He has a sly grin on his face, and we’re not sure just what he’s up to. He’s the “feeling guy” of deep emotions, soulful humor, and wild zaniness (as well as art and beauty, jokes and parties, tears and smiles, rough games and laughter). He is spontaneous and unpredictable. He’s the man who is interested in the deep inner life of possibilities and potential miracles. He’s full of life and play and unde"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("rstanding.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Everyone "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("loves him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Nothing’s Wrong")]), _vm._v(" is based on the idea that we need to be "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("both")]), _vm._v(" these guys: the gutsy, thinking astronaut "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("and")]), _vm._v(" the gutsy, fun-loving man in the moon. Because to be one without being the other is to be only half a person, to live only ha"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("lf a life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("There are several ways to talk about this half-life. You could say many men have a well developed thinking part and an underdeveloped feeling part. Or males are more logical and less sensitive; we are more serious, less playful. We are better at being workers than at bein"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("g friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Women might say about us: "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("He never wants to talk very much")]), _vm._v(" or "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("I never know what he’s really feeling")]), _vm._v(" or "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("He can be kind, but he doesn’t let you in")]), _vm._v(" or "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("I never seem to get to")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v(" know him.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Many of us males are playing the game of life with half the team missing. And we often wonder what’s going on, why things don’t work out bett"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("er for us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading1"
  }, [_vm._v("Men, Moon, and Mountain ")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("Here are a couple of stories about these two guys, astronaut-thinking guy and man-in-the-moon-fe"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("eling guy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("The first one happened in 1972—on the moon. Did you ever see the video of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Apollo 16")]), _vm._v(" astronaut John Young as he jumped up and down and waved his arms wildly during his walk on the moon? His behavior had nothing to do with the scientific purpose of the expedition. He was just having fun. He looked like an excited kid on a trampoline. The guys at Mission Control in Houston were probably not impressed. "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("What the hell is Young doing? He’s not supposed to do that! ")]), _vm._v(" His kids watching on TV probably got a hoot out of it. "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Wow! Loo")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("k at Dad! ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("In those few seconds, Young became a great example of both parts of male life: thinking (technical/logical) and feeling (artistic/spontaneous). He was, in that happy moment, the man on the moon "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("and")]), _vm._v(" the man in"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" the moon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Here’s another story. It also takes place up in the air, on the top of  Mount Everest, the highest mountain in the world, located in the rugged and remote northern highlands of Tibet. In 1953 Edmund Hillary, an explorer from New Zealand who was leading a British expedition, successfully scaled Mount Everest. He was the first human being to achieve this incred"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ible feat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("When Hillary completed his historic act of reaching the summit, exhausted but happy, the first thing he did was thrust the British flag deep into the snow to proclaim that he had conquered the"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" mountain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("But he wasn’t the only one there. His companion and guide, Tenzing Norgay, had also made the historic climb. Norgay was a Sherpa, one of the legendary mountain guides from northern Tibet. He was raised in a simple rural family, with a very different background from Edmun"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("d Hillary.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("As you might expect, Tenzing Norgay expressed himself in a different way. Upon arriving at the summit of the great mountain, he knelt down in the snow and prayed to the gods of the mountain, asking their forgiveness for disturbing th"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("eir peace.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("One man proclaimed his conquering achievement. The other prayed to the gods for pardon. The point I want to make is this: "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("We need both. Because we are both. ")]), _vm._v(" One is not right while the other is wrong. One is not weird and the other normal. No. "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("They are both healthy expressions of the m")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("ale life. ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("In this instance, you could say that Hillary expressed the thinking part and Norgay expressed the feeling part. But we know from their lives and writings that Norgay understood and applauded Hillary’s flag-thrust, while Hillary respected and affirmed Norgay"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("’s prayer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("The one needs the other. Even more, in order to live a complete life, each needs to "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("become")]), _vm._v(" the other. I want to make clear from the beginning that I do "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("not")]), _vm._v(" label one as good and the other as bad. That is the last thing I want to do. Both of these male aspects are good, and we must welcome both of them into "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("our lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading1"
  }, [_vm._v("Miseducation")]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPI"
  }, [_vm._v("One’s happiness depends less on what he knows than on what"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" he feels.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPIS"
  }, [_vm._v("—Liberty Hyde Bailey (1858–1954),"), _c('br'), _vm._v("botanist and horticulturist ")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("As males, our biggest problem is that on the subject of emotions, our culture is deeply biased. There are reasons why most boys and men, probably including you, have been “emotionally miseducated,” a term I’ve borrowed from Michael Thompson and Dan Kindlon’s book "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Raising Cain. ")]), _vm._v(" What they mean is that the combined forces of society steer a young male “away from his inner world.” This has an effect, they say, “even on the youngest boy, who learns quickly… that he must hide his feelings and silence his fears.” We carry that attitude, alive and well, into our ad"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ult lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("I believe this is true for all men: young and old, highly educated and less educated, raised in well-to-do families or in poor families, extroverts and introverts, straight and gay, urban businessmen and country ranchers, steel workers and family therapists, managers and employees, basketball players and poets—"), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("all")])]), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" of us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("While society tolerates some of what it sees as “male emotions,” like anger and aggression, it is generally uncomfortable with the free expression of all feelings by boys and men, and strongly resists teaching and promoting them. So our culture tries actively to steer you in the wrong direction. That’s something to take note of. As a result, of course, most men are good at thinking and not so good at"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" feeling. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("But that’s not all. There is also a physical basis for the way we are with our feelings. It’s the way our brains are “wired.” I’ll refer to a few of these characterist"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ics later.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading1"
  }, [_vm._v("Putting Words on Feelings")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("Given the culture in which we’ve been raised, it’s no wonder that many of us are challenged by the feeling part of life. We often can’t seem to recognize and talk about the feelings we are having at any giv"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("en moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("What we do instead is run away or cover up. As soon as we feel something, or someone else in our presence is feeling something—especially if it’s a strong feeling like fear or attraction—we run from it before it has a chance to let us know it’s there, much less get expressed. Running means changing the subject, distracting yourself with some other activity, or moving on to some"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("thing new.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Or we cover it. With TV, music, sports, humor, sex, laughter. Anything that covers over and hides the feelings that "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("are there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("So when someone asks us what we’re feeling, we can often truthfully say, “Oh, nothing.” We’re not lying, because we run so quickly from the feeling or cover it so well that we literally don’t know it"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" is there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Here are stories that two men, Jim and Derek, tell about themselves when they were boys. I want to start there because that’s when "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("it starts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading2B"
  }, [_c('span', {
    staticClass: "Wingdings_Elements _idGenCharOverride-4"
  }, [_vm._v("")]), _vm._v("  Jim’s Story  "), _c('span', {
    staticClass: "Wingdings_Elements _idGenCharOverride-4"
  }, [_vm._v("")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("Jim is forty-two, a civil engineer, husband, and father of two: “When I was a junior in high school I was fairly popular. In fact, everyone was expecting me to be elected homecoming king. But when the votes were in, I lost. I was fourth out of five. Everyone was surprised, including me. But what I said was ‘Oh, it’s OK, I didn’t really expect to get it. It’s no problem. It’s nothing.’ These were my typical responses to my parents, teachers, and"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" friends. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("“But what I was really feeling was painful embarrassment and shame. In fact, I can still feel it now as I talk about it, after all these years! Now, of course, I know what I was feeling, but for too long I just didn’t allow most of my feelings to "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("come out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Any normal human being would have those feelings. But Jim ran from them. Changed the topic. Got involved in something else. Denied any negative feelings. Probably put on his headphones and blasted the music. “This was exactly the occasion,” he adds, “when I started a pattern of no"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("nfeeling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("There’s a name for the condition I’m talking about: "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Alexithymia.")]), _vm._v(" It’s from Greek words meaning “no words for feelings.” A few of us guys have it really bad; most of us have at least a light c"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ase of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("The bad news is that it does a lot of damage to us. The good news is that, in the vast majority of cases, it’"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("s fixable.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('p', {
    staticClass: "Quote_BOXED_Quote-Box-no-space"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('br'), _vm._v("Alexithymia: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Quote_BOXED_Quote-Box-no-space"
  }, [_vm._v("“Difficulty in describing or recognizing one’s emo­­tions…” The word is “used to describe persons who define emotions only in terms of bodily sensations or behavioral reaction…”")]), _vm._v(" "), _c('p', {
    staticClass: "Quote_BOXED_Q-Attribution-Box"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Psychiatric Dictionary")])]), _vm._v(" "), _c('p', {
    staticClass: "Quote_BOXED_Quote-Box-no-space"
  }, [_vm._v("“A mood in which one has a constricted emotional life, diminished ability to fantasize, and a virtual inability to articulate emotions.”")]), _vm._v(" "), _c('p', {
    staticClass: "Quote_BOXED_Q-Attribution-Box"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Essential Psychopathology")])]), _vm._v(" "), _c('p', {
    staticClass: "Quote_BOXED_Quote-Box-no-space"
  }, [_vm._v("“People with alexithymia lack words for their feelings. Indeed, they seem to lack feelings altogether, although this may actually be because of their inability to "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("express")]), _vm._v(" emotion rather than an absence of emotion.”")]), _vm._v(" "), _c('p', {
    staticClass: "Quote_BOXED_Q-Attribution-Box"
  }, [_vm._v("Daniel Goleman, "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Emotional Intelligence"), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading2B"
  }, [_c('span', {
    staticClass: "Wingdings_Elements _idGenCharOverride-4"
  }, [_vm._v("")]), _vm._v("  Derek’s Story: “I Won’t Tell You”  "), _c('span', {
    staticClass: "Wingdings_Elements _idGenCharOverride-4"
  }, [_vm._v("")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("For most of us, these patterns began when we were boys. The story of Derek, now forty-four, begins during the end of his senior year in high school. This was a kid who had been in trouble forever. He was a middle child in a large and gregarious family. At this late date in the school year, it was doubtful if he would make the grades to"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" graduate.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Then he got caught by the vice principal smoking pot in the school parking lot. That was the point at which Derek literally shut up. He wouldn’t talk to anyone—family, friends, school counselor, pastor, teachers, or police—no one. He’d just look at the ground and shake"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" his head.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("His story slowly moves forward with very little life. He had to do community service for using a controlled substance. He did not graduate from high school. He got an unchallenging job and just sort of existed. Only now, in midlife, is he coming to his full emoti"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("onal life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("By titling Derek’s story “I "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("won’t")]), _vm._v(" tell you,” I make an assumption that he could have told us if he wanted. While I think that’s true, I don’t really know. That’s the frustrating thing about Derek and so many like him. We just don’t know what’s going on in their inner life. They won’t or can’t tell us. He had no words for his feelings, which remained locked up deep i"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("nside him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading2B"
  }, [_c('span', {
    staticClass: "Wingdings_Elements _idGenCharOverride-4"
  }, [_vm._v("")]), _vm._v("  Steve’s Story: “I Can’t Tell You”  "), _c('span', {
    staticClass: "Wingdings_Elements _idGenCharOverride-4"
  }, [_vm._v("")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("Here’s a story of a man who is very good at the thinking side. He is a member of Mensa—only very high IQs invited. His name is Steve. He and his wife, Amy, are in their late thirties, with two young kids, their own home, and successful working lives. They have come to see me, a family therapist, because their marriage is"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" troubled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("During our fifth or sixth session, without warning, Amy says she believes their marriage cannot survive and she wants a divorce. Bam! just l"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ike that. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("To this sobering announcement Steve reacts with a sad, vacant stare into space. It lasts a long fifteen seconds; no one says a word. I am as surprised as he is. Then, without saying anything, he calmly stands up, picks up his coat and briefcase, and walks out of "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("my office.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Jump ahead "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("two weeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("After several attempts, I convince Steve to come in on his own “to talk about it.” When he comes to my office, I can feel him bristle. He doesn’t want to be here. We start talking; or rather, I start talking. From him I get nothing but grunts, noises, or shakes of the head. Clearly he is in pain. A couple times he glances at me, silently begging me to end the torture and let him go. He just can’t say much of"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("After one particularly long period of silence, I notice I am really getting annoyed and think to myself, "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("This must be what his wife feels.")]), _vm._v(" Then I ask, “Well, Steve, what about just telling me, briefly, what you are feeling right now, knowing that your wife intends to div"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("orce you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("His response begins slowly, then quickly builds force as his eyes snap wide to attention, rise up and rivet me. His face becomes flushed, his body rigid, his fists clenched, and his loo"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("k enraged.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Then he bolts from his seat, storms across the room, turns back toward me—now fevered and furious—raises his arms high (to attack? to entreat?) and literally screams, “You sound just like my wife! Don’t you see?” And then even louder and more anguished, “I don’t know what I’m"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" feeling!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("When my heart returns to its normal beat and I take a deep breath or two—he is now slumped in his chair, spent and embarrassed—I say in a quiet vo"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ice, “Oh.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("After a moment I said it again, “Oh.” I could only hope the simple word expressed what I wanted him to know: that I heard him, not just his words—I’m sure half the building heard thos"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("e—but him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("More importantly, I wanted him to know that I actually believed him: he did not know what he was feeling about his marriage, his possible divorce, and even about"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" his wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Steve simply did not know his emotional state, and thus could not put it into words. He knew he was in pain, but beyond that, he simply didn’t know. It wasn’t that he didn’t want to know. In fact he did want to know. It wasn’t that he really knew but just wouldn’t tell me. No, he really "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("didn’t know.")]), _vm._v(" He truly had no words for his"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" feelings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Steve was a man in his late thirties when this happened. He was so used to not knowing his feelings that he didn’t know that he di"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("dn’t know.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading2"
  }, [_vm._v("It’s Not Too Late")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("In this situation—not being able to put into words the emotions you are experiencing—many men find we are misjudged as stuck-up or stubborn or even stupid. Sometimes we even judge ourselves with those words. But in the vast majority of situations this is not true. Almost always what we are going through are the effects of our lack of training in the ways of dealing with"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" feelings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Many times, when the feelings finally do come out, they come out in an explosion, like Steve’s did. And often they get us into trouble. At best we’re accused of overreacting; at worst we’re seen as fearsome or violent. It’s a no-win "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("situation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("There’s a point I want to make with the stories of Jim, Derek, and Steve: If you begin "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("now")]), _vm._v(" to find ways to attach words—or some other healthy means of expression—to your feelings, you can avoid the sad situations that the three of them got into. This is indeed what you are doing by reading this book. It’s never "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("too late! ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Today Steve continues his slow but sure journey to emotional fitness. Although he and his wife separated for a few months, they both did four months of counseling and he joined a weekly men’s group. They got together again and are now giving the marriage a second chance. In fact, it is from our work together several years ago that this book began to t"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ake shape.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("And Derek? It’s an on-going story. When we last met, the signs were good. The reason for these changes is that he had “met someone” and was very interested in her. But she did not want a half-living partner. I’m betting he’s been successful. He was really tired of living ha"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("lf a life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading1"
  }, [_vm._v("Emotional Literacy ")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("In our culture, feelings are not talked about very much. Un­for­tunately, you can’t take a course in feelings at any school. All human beings, male and female, have feelings and have the capacity for the full range of emotional expression. But sometimes boys and men act, and are treated, as if we just don’t "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("have")]), _vm._v(" any"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" feelings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Another way to talk about this is with the term “emotional literacy,” which is about being comfortable with the language of feelings. We all have a history—the stories of our successes and failures—of dealing with our feelings, and it is helpful to know what your h"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("istory is.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_Centered-Bold"
  }, [_vm._v("Your Relationship to Feelings")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("Here are a few questions, broadly based on Claude Steiner’s "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("When a Man Loves a Woman,")]), _vm._v(" to help you find out about your relationship with feelings. Read them over and keep track of your “yeses” a"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("nd “noes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers-First"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("1.")]), _vm._v("Do your feelings sometimes puzzle you? Are you sometimes unable to understand them or know what to do a"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("bout them?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("2.")]), _vm._v("Do your feelings sometimes get out of control? Like a feeling of anger? Or feeling sad and "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("depressed?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("3.")]), _vm._v("Do you sometimes feel very alone and left out, with the sense that you are missing out on something "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("important?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("4.")]), _vm._v("Do people complain that you are a loner? Different from everyone else? That you are cold? Stuck"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("-up? Mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("5.")]), _vm._v("Do you have trouble getting to know friends more than just"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" casually?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("6.")]), _vm._v("Do you experience your feelings of liking others as coming and going and changin"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("g quickly?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("7.")]), _vm._v("Are you embarrassed to ask for what you want or to talk about b"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("eing hurt?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("8.")]), _vm._v("Do you have trouble crying? Or do you "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("cry a lot?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("9.")]), _vm._v("Do you avoid emotional situations like good-byes? Or people who are grievin"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("g or sick?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("10.")]), _vm._v("Are you embarrassed when someone shows affection for you "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("in public?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("11.")]), _vm._v("Do you sometimes avoid feelings by expecting the females in your life—family member, wife, friend—to live your emotional lif"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("e for you?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("If you answered “yes” to some or all of these questions or if your “noes” were weak or doubtful, then you’re just like most of us guys. Like the rest of us, you have a degree of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("emotional illiteracy;")]), _vm._v(" you are sometimes at a loss when it comes to knowing what to do about feelings. “Now what do I do?” is often as far "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("as we get.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading1"
  }, [_vm._v("The Inner Life")]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPI"
  }, [_vm._v("When I do good, I feel good. When"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" I do bad,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPI"
  }, [_vm._v("I feel bad. And that’s my"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" religion.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPIS"
  }, [_vm._v("—Abraham Lincoln")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("For many, “the inner life” might not be a very hot topic. The sound of it might even make you nervous. This is where “guts” comes into the process. Right now is when I need you to hang in there. Why? Because lifelong misery begins right here. The very words "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("inner life")]), _vm._v(" can make us nervous. It is precisely here, your inner life, where most guys get into trouble and stay there for their whole lives. Bear with me for a few paragraphs and I think you’"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ll see it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("First, what do I mean by the “inner life”? There are a lot of ways to answer that. You actually know what it is, of course, but it is difficult to describe. So that we’re on the same page, here is a free-flowing description of some of the things that make up the in"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ner life. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("The inner life is the life you live when you are alone and just thinking. Everything that you fantasize and imagine is part of it. It is what you feel when you see someone you like, or dislike. It’s what you experience when you think of an enjoyable event or a terrible one. It’s everything in your life that is not visible in some way—love, understanding, jealousy, and those kinds of intangible values. It’s what moves you, what motivates you to do what you do and be who you are. Your inner life determines your character, your qualities, your vices, your virtues, what you value a lot, what you don’t value at all. It’s your loves, your hates, your fun, your fears—but especially it’s you"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("r secrets.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("It’s the part you can keep hidden, but it’s the part that everyone sees the results of. That’s because your inner life determines your response to your “outer life” or the part of your life that others can perceive, like what you say, where you go, your gestures, your words, your smiles, your scowls. In other words, the inner life has its hands on the controls of your being and tells the outer life what to do and what not to do, how to respond, what to avoid. Your inner life is "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("everything you feel,")]), _vm._v(" the entire range of your emotions, and therefore ultimately controls your life, whether you are aware of "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("it or not.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Keep three things in mind about the i"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("nner life:")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers-First"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("1.")]), _vm._v("There is a man’s way to navigate the inner life (The Three Steps to Emotional Fitness in "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("chapter 4)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("2.")]), _vm._v("The more congruence (or agreement, or harmony) between your inner life and your outer life, the more integrated or mature your pe"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("rsonality.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Numbers"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-1"
  }, [_vm._v("3.")]), _vm._v("The inner life has "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("the power.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("Some of the other words that many of us use when talking about the inner life are: soul, mind, self, a"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("nd spirit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Religion is very interested in the inner life. In fact, religion is the primary practice that some men use to navigate the territory. Everything presented in this book is totally compatible with the practice of any and all religious faith. It is equally compatible with a life that holds no religious practice at all, or, like Abraham Lincoln (quoted above), with a life that follows its own kind of"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" religion.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("At this point maybe you’re thinking something like: "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Wait a minute! Wait a minute! Alexithymia? Emotionally illiterate? No inner life?")]), _vm._v(" To paraphrase a gang member in "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("West Side Story,")]), _vm._v(" “Gee, Officer Krupke, no wonder I’m"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" a mess!” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("But wait, please! These are all really the same thing: limited skill with feelings. They’re just different ways of looking at it. So no, you’re not a mess. You carry on just fine. Many of us have amazing skills at “faking it” and getting through life quite well without half of our "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("resources.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("On the other hand, yes, part of you, like most of us guys, probably is a bit of a mess. My guess is that a few of us are in pretty rough shape in this regard, another few of us are real emotional pros, and most of us are on the high or low end of muddlin"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("g through.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("It takes some guts to admit that. I hope you see that while it certainly takes guts to follow the astronaut to the moon, which is exploring the outer life, it takes equally as much courage—or more—to follow the man in the moon on the journey within. The path you are now walking is a path o"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("f courage.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("The bottom line? If your inner life is taken care of, it will respond just as your body does to good care. It will not only survive, it will thrive. By becoming skillful in the area of your feelings, you are caring for your inner life. You’re taking care of the real you, looking out for Number One, not in the way of selfishness, but in the way of responsibility, which is another name for"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" maturity.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Heading1"
  }, [_vm._v("A Question")]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPI"
  }, [_vm._v("A person buying products in a supermarket is in touch with his deepest"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" emotions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPIS"
  }, [_vm._v("—John Kenneth Galbraith, economist")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body_First"
  }, [_vm._v("The question that chapter 1 leads to is this: Are you aware of your feelings and can you express them successfully? This is a question that only you can answer. Spend some time thinking about it and see what you come up with. Here’s the question again: "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Are you aware of your feelings and can you express them succ")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("essfully? ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("Very few, if any, of us would respond with a definitive yes or no to that question. Some of us might have a more or less clear answer. But you are not unusual if you do not have sufficient awareness of your feelings to make an informed answer right away. Many of us are not at all sure what degree of skill we have with feelings. Or again, you may feel embarrassed or uncomfortable with the question itself. Or you may be puzzled by the question, still not sure just what I"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("’m asking.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("If you answered “no” or “I’m not sure,” or even if you answered “yes” or “I think so,” the information in this book can help you determine if your answer is accurate or help you clarify yo"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ur doubts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Body"
  }, [_vm._v("One thing is sure: when you finish this brief but adventurous journey, chances are excellent that you’ll be better able to get more of what you want in life. Why? Because you’ll be leading a "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("whole")]), _vm._v(" life. The astronaut/thinking you will shake hands with the man in the moon/feeling you and they will be strangers no more; they’ll be friends and allies, united in th"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("e one you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Review_Heading"
  }, [_vm._v("A Few Suggestions for Review")]), _vm._v(" "), _c('p', {
    staticClass: "Body_Bullets_Review"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-2"
  }, [_vm._v("•")]), _vm._v("Which of the two are you most like, the logical astronaut walking on the moon or the unpredictable, playful man in"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" the moon?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Bullets_Review"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-2"
  }, [_vm._v("•")]), _vm._v("Of course either answer to that question is correct because both are good and necessary. Maybe you have parts of both. If so, can you put an approximate percentage"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" on each? ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_Bullets_Review _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "_idGenBNMarker-2"
  }, [_vm._v("•")]), _vm._v("Jim, Derek, and Steve were all unable to “speak” in some way. They couldn’t get what was happening in their inner lives into the outer world. Thus they could not accomplish what they needed and wanted. You ever be"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("en there? ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777843cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NothingsWrong-8.vue
// module id = 84
// module chunks = 0